export const GET_MANAGER_INSIGHTS_REQUEST = 'GET_MANAGER_INSIGHTS_REQUEST';
export const SET_MANAGER_INSIGHTS_SELECTED_STORE =
  'SET_MANAGER_INSIGHTS_SELECTED_STORE';
export const GO_TO_MANAGER_INSIGHTS_TEAMS_PAGE =
  'GO_TO_MANAGER_INSIGHTS_TEAMS_PAGE';
export const GO_TO_MANAGER_INSIGHTS_TRAINING_PAGE =
  'GO_TO_MANAGER_INSIGHTS_TRAINING_PAGE';
export const GO_TO_MANAGER_INSIGHTS_LEARNER_PERFORMANCE_PAGE =
  'GO_TO_MANAGER_INSIGHTS_LEARNER_PERFORMANCE_PAGE';
export const GO_TO_MANAGER_INSIGHTS_CONTENT_PERFORMANCE_PAGE =
  'GO_TO_MANAGER_INSIGHTS_CONTENT_PERFORMANCE_PAGE';
export const OTP_ERROR = 'OTP_ERROR';
export const RESET_OTP_ERROR = 'RESET_OTP_ERROR';
export const MANAGER_LOGGED_IN = 'MANAGER_LOGGED_IN';
